import { Environment, ViewMode } from '@40seas/entities/common';
import { UserRole } from '@40seas/entities/users';
import { useAppStore } from '@40seas/frontend/dashboard/contexts';
import { useDashboardToken } from '@40seas/frontend/dashboard/hooks';
import { useSetupData, useUser } from '@40seas/frontend/libs/hooks';
import { useFeatureToggleClient } from '@40seas/frontend/libs/providers';
import { UrlsProvider } from '../providers/urlsProvider';
import { isGuestRole } from '@40seas/frontend/libs/hooks';
import { useAuth } from './useAuth';

const useInitDataProviderParams = () => {
    const setup = useSetupData();
    const { isAuthenticated, getAccessTokenSilently } = useAuth();
    const apiUrl = setup.urls.API_URL.endsWith('/') ? `${setup.urls.API_URL}v1` : `${setup.urls.API_URL}/v1`;
    const urlsProvider = new UrlsProvider(apiUrl);
    const { isTestMode, organization, tenant, viewMode, urlRole } = useAppStore();
    const { overrideFeatureToggleValues } = useFeatureToggleClient();
    const user = useUser();
    const { guestToken } = useDashboardToken();

    const getHeaders = async () => {
        const headers: any = {
            '40seas-environment': isTestMode ? Environment.Sandbox : Environment.Live,
        };

        if (isAuthenticated) {
            headers.Authorization = `Bearer ${await getAccessTokenSilently()}`;
        }

        if (organization?.id) {
            headers['40seas-organization'] = organization?.id;
        }

        if (tenant && viewMode !== ViewMode.Buyer) {
            headers['40seas-tenant'] = tenant;
        }

        if (urlRole) {
            headers['40seas-role'] = urlRole;
        }

        if (isGuestRole(user?.role as UserRole) && guestToken) {
            headers['40seas-token'] = guestToken;
        }

        if (overrideFeatureToggleValues) {
            for (const key in overrideFeatureToggleValues) {
                headers[`40seas-ft-${key}`] = overrideFeatureToggleValues[key];
            }
        }

        return headers;
    };

    return { apiUrl, urlsProvider, getHeaders, tenant };
};

export default useInitDataProviderParams;
